var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-filter-group"},[(_vm.label)?_c('h4',[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.subTitle)?_c('div',{staticClass:"sub-title"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }